var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSetChargingPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.6 52.5V65.1518L109.213 66.4286L82.2719 93.5893L81.6938 97.0714H44V52.5H110.6ZM84.7 78.5H73.6V82.2143H84.7V78.5ZM73.6 67.3571V71.0714H95.8V67.3571H73.6ZM62.9625 63.6429V61.3214H58.3375V63.6429V64.3393C57.6438 64.4554 57.0656 64.6875 56.4875 64.9196C54.7531 65.7321 53.25 67.2411 52.9031 69.3304C52.6719 70.4911 52.7875 71.6518 53.25 72.6964C53.7125 73.7411 54.5219 74.4375 55.2156 75.0179C56.6031 75.9464 58.3375 76.4107 59.725 76.875H59.9563C61.575 77.4554 62.6156 77.8036 63.3094 78.2679C63.6562 78.5 63.7719 78.6161 63.7719 78.7321C63.7719 78.8482 63.8875 79.0804 63.7719 79.5446C63.7719 79.8929 63.5406 80.2411 62.8469 80.5893C62.1531 80.8214 60.9969 80.9375 59.4938 80.7054C58.8 80.5893 57.6438 80.2411 56.4875 79.8929C56.2563 79.7768 56.025 79.6607 55.7938 79.5446L53.5969 78.8482L52.0938 83.2589L54.2906 83.9554C54.4062 84.0714 54.6375 84.0714 54.8688 84.1875C55.7938 84.5357 57.1813 85 58.3375 85.2321V85.9286V88.25H62.9625V85.9286V85.3482C63.5406 85.2321 64.1188 85 64.6969 84.7679C66.5469 84.0714 67.9344 82.5625 68.3969 80.3571C68.5125 79.0804 68.5125 77.9196 68.05 76.875C67.5875 75.8304 66.7781 75.1339 66.0844 74.5536C64.6969 73.5089 62.7313 72.9286 61.3438 72.4643H61.2281C59.6094 72 58.5688 71.6518 57.875 71.1875C57.5281 70.9554 57.4125 70.8393 57.4125 70.7232C57.4125 70.7232 57.2969 70.6071 57.4125 70.1429C57.4125 69.9107 57.6438 69.5625 58.3375 69.2143C59.0313 68.8661 60.1875 68.75 61.6906 68.9821C62.1531 68.9821 63.7719 69.3304 64.1188 69.4464L66.4313 70.0268L67.5875 65.5L65.3906 64.9196C64.8125 64.8036 63.6562 64.5714 62.9625 64.4554V63.6429ZM109.791 71.0714L118 79.3125L113.144 84.1875L104.934 75.9464L109.791 71.0714ZM102.391 78.5L110.6 86.7411L94.1813 103.107L84.7 104.5L85.9719 94.8661L102.391 78.5Z",
    fill: "url(#paint0_linear_9687_119797)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9687_119797",
    x1: 81,
    y1: 52.5,
    x2: 81,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSetChargingPrice);
export default __webpack_public_path__ + "static/media/img_set_charging_price.81ee55a5e60bc3456b4f73b6b022ebca.svg";
export { ForwardRef as ReactComponent };